<template>
  <div id="admins" class="page">
    <Pagination :page="$store.state.admins.page" :total="$store.state.admins.total" :perPage="$store.state.admins.limit"
      @click="pageHandler" />

    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="control has-icons-left search-control">
            <input class="input" type="search" v-model="$store.state.admins.search" placeholder="Пошук" />
            <span class="icon is-left">
              <i class="fas fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="level-right">
        <div class="level-item">
          <h2 class="title is-5 text-overflow">
            Total: {{ $store.state.admins.total }}
          </h2>
        </div>
      </div>
    </div>
    <div class="box">
      <table class="table is-striped is-fullwidth">
        <thead>
          <tr>
            <th>username</th>
            <th>Email</th>
            <th>role</th>
            <th>Permissions</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user) in $store.state.admins.list" :key="user.id">
            <template v-if='updateAdmin && updateAdmin.id == user.id'>
              <td><input type="text" v-model='updateAdmin.username' /></td>
              <td><input type="text" v-model='updateAdmin.email' /></td>
              <td>
                <select v-model="updateAdmin.role">
                  <option value="admin">Admin</option>
                  <option value="moderator">Moderator</option>
                </select>
              </td>
              <td>
                <div style="display: flex; flex-wrap: wrap;">
                  <label v-for="(value, key) in updateAdmin.permissions" :key="key" style="margin-right: 10px;">
                    <input type="checkbox" :value="key" v-model='updateAdmin.permissions[key]'>
                    {{ key }}
                  </label>
                </div>
              </td>
              <td> <button class="button is-small is-success has-tooltip-bottom" data-tooltip="Save" @click="save">
                  <span class="icon is-small">
                    <i class="fas fa-check"></i>
                  </span>
                </button>
                <button class="button is-small is-danger has-tooltip-bottom" data-tooltip="Cancel" @click="cencel()">
                  <span class="icon is-small">
                    <i class="fas fa-times"></i>
                  </span>
                </button>
              </td>

            </template>
            <template v-else>
              <td>{{ user.username }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.role || '—' }}</td>
              <td>
                <span v-for="(value, key) in user.permissions" :key="key">
                  <template v-if="value">{{ key }}, </template>
                </span>
              </td>
              <td>
                <button class="button is-small is-info has-tooltip-bottom" data-tooltip="Редагувати"
                  @click="setUpdate(user)">
                  <span class="icon is-small">
                    <i class="fas fa-edit"></i>
                  </span>
                </button>
                <button class="button is-small is-danger has-tooltip-bottom" data-tooltip="Видалити"
                  @click="remove(user)">
                  <span class="icon is-small">
                    <i class="fas fa-trash-alt"></i>
                  </span>
                </button>
              </td>
            </template>

          </tr>
          <template v-if='updateAdmin && updateAdmin.id == null'>
            <tr>
              <td><input type="text" v-model='updateAdmin.username' /></td>
              <td><input type="text" v-model='updateAdmin.email' /></td>
              <td>
                <select v-model="updateAdmin.role">
                  <option value="admin">Admin</option>
                  <option value="moderator">Moderator</option>
                </select>
              </td>
              <td>
                <div style="display: flex; flex-wrap: wrap;">
                  <label v-for="(value, key) in updateAdmin.permissions" :key="key" style="margin-right: 10px;">
                    <input type="checkbox" :value="key" v-model='updateAdmin.permissions[key]'>
                    {{ key }}
                  </label>
                </div>
              </td>
              <td> <button class="button is-small is-success has-tooltip-bottom" data-tooltip="Save" @click="save">
                  <span class="icon is-small">
                    <i class="fas fa-check"></i>
                  </span>
                </button>
                <button class="button is-small is-danger has-tooltip-bottom" data-tooltip="Cancel" @click="cencel()">
                  <span class="icon is-small">
                    <i class="fas fa-times"></i>
                  </span>
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <label style="display: flex; flex-wrap: wrap; gap: 4px;"><span>Password </span>
                  <input :type="showPassword ? 'text' : 'password'" v-model='updateAdmin.password'
                    placeholder="Пароль" />
                  <button class="button is-small" type="button" @click="showPassword = !showPassword">
                    <span class="icon is-small">
                      <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </span>
                  </button>
                </label>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <button class="button is-primary mt-4" v-if='!updateAdmin' @click="setUpdate(defaultUser)">
        add admin
      </button>
    </div>

    <Pagination :page="$store.state.admins.page" :total="$store.state.admins.total" :perPage="$store.state.admins.limit"
      @click="pageHandler" />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

const defaultUser = {
  id: null,
  username: "",
  email: "",
  role: "admin",
  permissions: {
    read: false,
    write: false,
    delete: false
  },
  password: "",
};

export default {
  name: "admins",
  components: {
    Pagination,
  },
  data: () => ({
    searchTimeout: null,
    defaultUser: { ...defaultUser },
    updateAdmin: null,
    showPassword: false,
  }),
  watch: {
    "$store.state.admins.search"() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getAdminList();
      }, 1000);
    },
    $route() {
      this.pageDetect();
      this.getAdminList();
    }
  },
  methods: {
    getAdminList() {
      return this.$store
        .dispatch("getAdminList")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Get admin list error",
            text
          });
        })
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "admins",
            status: false
          });
        });
    },
    pageDetect() {
      this.$store.state.admins.page = parseInt(this.$route.params.page);
    },
    pageHandler(page) {
      this.$router.push({
        name: "Admins",
        params: {
          page
        }
      });
    },
    create(obj) {
      if (confirm("Create admin?")) {
        this.$store
          .dispatch("createAdmin", obj)
          .then(result => {
            Object.keys(defaultUser).forEach(
              key => (this.defaultUser[key] = defaultUser[key])
            );
            if (!result) {
              this.$notify({
                type: "error",
                title: "Admin has not created",
                text: "Check user data"
              });
            } else {
              this.cencel();
              return //this.getAdminList();
            }
          })
          .catch(text => {
            this.$notify({
              type: "error",
              title: "Create admin error",
              text
            });
          });
      }
    },
    setUpdate(user) {
      this.updateAdmin = { ...user, permissions: { ...user.permissions } };
    },
    cencel() { this.updateAdmin = null },
    save() {
      if (!this.updateAdmin) return;
      if (this.updateAdmin.id) {
        this.update(this.updateAdmin);
      } else {
        this.create(this.updateAdmin);
      }
    },
    update(obj) {
      if (obj.id) {
        this.$store.dispatch("updateAdmin", obj).then(() => {
          this.cencel();
        }).catch(text => {
          this.$notify({
            type: "error",
            title: "Save user error",
            text
          });
        });
      } else {
        Object.keys(obj).forEach(key => (this.defaultUser[key] = obj[key]));
      }
    },
    removeDevice({ userId, id }) {
      this.$store.dispatch("removeUser", { userId, id }).catch(text => {
        this.$notify({
          type: "error",
          title: "Remove device error",
          text
        });
      });
    },
    async remove({id}) {
      if (confirm("Remove this admin?")) {
        const result = await this.$store.dispatch("removeAdmin", id).catch(text => {
          console.log(text);
          this.$notify({
            type: "error",
            title: "Remove admin error",
            text
          });
        });
        if (result) {
          this.getAdminList();
        }
      }
    }
  },
  mounted() {
    this.getAdminList();

    this.pageDetect();
  }
};
</script>
